import React, { useState, useEffect } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { createpassword, getMemberRegistrationStatusByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import notify from "../../Helpers/ToastNotification";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import { AllRoutes } from "../../Routes/router";
import { Decrypt } from "../../Helpers/Cryptography/Crypto";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import "./CreatePassword.css";
import { useDispatch, useSelector } from "react-redux";
import { MemberRegistrationUserType } from "../../Helpers/Enums/MemberRegistrationUserType";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import moment from "moment";
import { setMemberRegistrationUserType } from "../../Redux/Actions/MemberRegistrationActions";

const CreatePassword = (props) => {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const { state } = useLocation();
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [enterPass, setEnterPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [isPasswordCreated, setPasswordCreated] = useState(false);
  const [disabled, setDisabled] = useState();
  const { previous } = props;
  const [isSubmitClicked, setIsSubmitClicked] = useState<boolean>(false);
  const [error, setErrors] = useState({});
  const [statusData, setStatusData] = React.useState(props?.statusData);
  const [isFieldsVisible, setIsFieldsVisible] = useState(false);
  const memberid = GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  const userTypeId: MemberRegistrationUserType = useSelector((state: any) => state?.MemberRegistrationReducer?.userTypeId);

  const [validationList, setValidationList] = useState<Array<any>>([
    { isSuccess: false, message: "1 Capital letter" },
    { isSuccess: false, message: "1 Numeric character" },
    { isSuccess: false, message: "1 Special character" },
    { isSuccess: false, message: "Minimum 8 character" },
    { isSuccess: false, message: "Maximum 16 character" },
  ]);

  useEffect(() => {
    getMemberIdStatusDetails();
  }, []);

  // useEffect(() => {
  //   if (userTypeId) {
  //     switch (userTypeId) {
  //       case MemberRegistrationUserType.Officers:
  //         setIsFieldsVisible(false);
  //         break;
  //       case MemberRegistrationUserType.Staff:
  //         setIsFieldsVisible(true);
  //         break;
  //     }
  //   }
  // }, [userTypeId]);

  const getMemberIdStatusDetails = async () => {
    let url = `${getMemberRegistrationStatusByMemberId}`;
    let requestBody = { MemberId: memberid };
    
    const getData = await APICall(url, requestBody);
    if (getData.Data != null) {
      const IsAccountCreated = getData.Data.IsAccountCreated;
      const statusId = getData.Data.StatusId;
      const MemberIdCreationDate = moment().add(1, "months").startOf("month").format("DD MMMM YYYY");
      // const MemberIdCreationDate = moment().isSame(
      //   moment().startOf("month"),
      //   "day"
      // )
      //   ? moment().format("DD MMMM YYYY")
      //   : moment().add(1, "months").startOf("month").format("DD MMMM YYYY");

      if (!getData?.Data?.MemberIdCreationDate) {
        getData.Data.MemberIdCreationDate = MemberIdCreationDate;
      }
      setStatusData(getData.Data);
      dispatch(setMemberRegistrationUserType(getData?.Data?.ApplicantType));
   

      if (statusData?.StatusId === ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted) {
        if (IsAccountCreated) {
          setIsFieldsVisible(false);
        } else {
          if (statusData?.ApplicantType === MemberRegistrationUserType.Officers) {
            setEnterPass("NonUsedPass");
            setConfirmPass("NonUsedPass");
            await onSubmit();
          } else if (statusData?.ApplicantType === MemberRegistrationUserType.Staff) {
            setIsFieldsVisible(true);
          }
        }
      }
    }
  };

  const onChange = async (key: any, value: any) => {
    if (key === "password") {
      let val = value.target.value;
      setEnterPass(val);
      let capital = /.*[A-Z].*/.test(val);
      let numeric = /.*\d.*/.test(val);
      let spclCharacter = /.*[!@#$%^&*()\-_=+{}[\]:;"'<>,.?].*/.test(val);

      await setErrors({
        ...error,
        ["Password"]: " ",
      });

      if (capital === false) {
        await setErrors({
          ...error,
          ["Password"]: "1 Capital Letter is required",
        });
      }
      if (numeric === false) {
        await setErrors({
          ...error,
          ["Password"]: "1 Numeric is required",
        });
      }
      if (spclCharacter === false) {
        await setErrors({
          ...error,
          ["Password"]: "1 Special Character is required",
        });
      }
    }
    if (key === "confirmpassword") {
      let val = value.target.value;
      setConfirmPass(val);
      await setErrors({
        ...error,
        ["confirmPassword"]: " ",
      });
      if (val != enterPass) {
        await setErrors({
          ...error,
          ["confirmPassword"]: "Confirm Password Should be same as Password",
        });
      }
    }
  };

  const onSubmit = async () => {
    let errorobj = {};
    if (enterPass == "") {
      errorobj = {
        ...errorobj,
        ["Password"]: "This field is Required",
      };
    }
    if (confirmPass == "") {
      errorobj = {
        ...errorobj,
        ["confirmPassword"]: "This field is Required",
      };
    }

    if (enterPass != confirmPass) {
      errorobj = {
        ...errorobj,
        ["confirmPassword"]: "Confirm Password Should be same as Password",
      };
    }

    if (Object.keys(errorobj).length === 0) {
      showLoader();
      let obj = {
        MemberId: memberid,
        Password: enterPass,
        ConfirmPassword: confirmPass,
      };
      const insertData = await APICall(createpassword, obj);

      if (insertData.Data != null && userTypeId === MemberRegistrationUserType.Staff) {
        notify(0, "Password Created Successfully");
        //navigate("/login");
        setPasswordCreated(true);
        setIsFieldsVisible(false);
      }
      hideLoader();
    }

    setErrors(errorobj);
  };

  enum TextInputTarget {
    Password,
    ConfirmPassword,
  }

  const checkValidation = (value: string, target: TextInputTarget) => {
    switch (target) {
      case TextInputTarget.Password:
        const newValidationList = [];
        newValidationList.push({
          isSuccess: /.*[A-Z].*/.test(value),
          message: "1 Capital letter",
        });
        newValidationList.push({
          isSuccess: /.*\d.*/.test(value),
          message: "1 Numeric character",
        });
        newValidationList.push({
          isSuccess: /.*[!@#$%^&*()\-_=+{}[\]:;"'<>,.?].*/.test(value),
          message: "1 Special character",
        });
        newValidationList.push({
          isSuccess: value.length > 8,
          message: "Minimum 8 character",
        });
        newValidationList.push({
          isSuccess: value.length < 16,
          message: "Maximum 16 character",
        });
        setValidationList(newValidationList);
        break;
      case TextInputTarget.ConfirmPassword:
        break;
    }
  };

  const onTextChanged = (event, target: TextInputTarget) => {
    const value = event.target.value;
    setErrors({
      ...error,
      ["confirmPassword"]: " ",
    });
    switch (target) {
      case TextInputTarget.Password:
        setEnterPass(value);
        checkValidation(value, target);
        break;
      case TextInputTarget.ConfirmPassword:
        setConfirmPass(value);
        break;
    }
  };

  const ValidationSpan = (props) => {
    const { isSuccess, message } = props;
    return (
      <span className={"px-3 " + (isSuccess ? "text-success" : "text-danger")}>
        <i className={`fas fa-solid ${isSuccess ? "fa-check" : "fa-times"} px-2`}></i>
        {message}
      </span>
    );
  };

  return (
    <>
      {statusData?.StatusId === ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted && (
        <div style={{ textAlign: "center", fontWeight: "bold", color: "#DB233A" }}>Member No : {statusData?.MemberNo || ""}</div>
      )}
      <div style={{ textAlign: "center", fontWeight: "bold" }}>Congratulations ! You have successfully enrolled.</div>
      {statusData?.StatusId === ApplicationStatus.MemberRegistrationModule_MemberRequestApproved && (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Your member enrolment request is approved. Your Member No. will be generated on 1st of next month. (i.e. {statusData?.MemberIdCreationDate})
        </div>
      )}
      {statusData?.StatusId === ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted && (isPasswordCreated || statusData?.IsAccountCreated) && (
        <div style={{ textAlign: "center" }}>
          <a
            style={{ textAlign: "center", fontWeight: "bold" }}
            onClick={() => {
              navigate(AllRoutes.login.link);
            }}
          >
            <span style={{ color: "#007bff", textDecoration: "underline" }}>Click here</span> to login
          </a>
        </div>
      )}
      {isFieldsVisible ? (
        <div>
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            Please setup your password to{" "}
            <a style={{ color: "#007bff", textDecoration: "underline" }} href={AllRoutes.login.link}>
              login
            </a>{" "}
            to your member account
          </div>
          <div className="mx-3">
            <div className="col-lg-12 col-md-12 mt-3">
              <div className="row">
                <div className="col-lg-4 col-sm-4 col-xs-4 " style={{ marginLeft: "35%" }}>
                  <label>Enter Password</label>
                  <InputForm
                    value={enterPass}
                    type="password"
                    placeholder={""}
                    isDisabled={disabled}
                    onChange={(event: React.ChangeEvent) =>
                      //onChange("password", event)
                      onTextChanged(event, TextInputTarget.Password)
                    }
                  />
                  <p style={{ color: "red" }}>{error["Password"]}</p>
                </div>
                <div className="col-lg=4 col-sm-4 col-xs-4" style={{ marginLeft: "35%" }}>
                  <label>Confirm Password</label>
                  <InputForm
                    value={confirmPass}
                    placeholder={""}
                    type="password"
                    isDisabled={disabled}
                    onChange={(event: React.ChangeEvent) =>
                      //onChange("confirmpassword", event)
                      onTextChanged(event, TextInputTarget.ConfirmPassword)
                    }
                  />
                  <p style={{ color: "red" }}>{error["confirmPassword"]}</p>
                </div>
                <div className="col-lg=4 col-sm-4 col-xs-4" style={{ marginLeft: "35%" }}>
                  <div className="p-3">
                    <ul>
                      <span className="font-weight-light font-italic">Password must contain : </span>
                      <div className="d-flex flex-column">
                        {validationList.map((v) => {
                          return <ValidationSpan {...v} />;
                        })}
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      ) : // <div className="sso-container">
      //   <div className="sso-icon-container">
      //     <i className="fa-solid fa-unlock-keyhole sso-icon"></i>
      //   </div>
      //   <a
      //     className="sso-button"
      //     href="https://ccservice-dev.m-devsecops.com/auth/login?id=825be375-41ca-4731-92a1-c7ce4cae329d&env=DEV"
      //   >
      //     Login with SSO
      //   </a>
      // </div>
      null}

      <div className="d-flex justify-content-center mt-2">
        <ButtonComponent icon={"fas fa-arrow-left"} value={"Back"} style={{ marginRight: "20px" }} onClick={previous} />
        {isFieldsVisible ? <ButtonComponent icon={"fas fa-arrow-right"} value={"Save"} id={"saveBtn"} onClick={() => onSubmit()} /> : null}
      </div>
    </>
  );
};
export default CreatePassword;
